import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import "./alert.scss";

const Alert = ({ type = "info", children, inline, className, ...props }) => {
  const classes = classnames(
    "alert",
    {
      "alert--success": type === "success",
      "alert--warning": type === "warning",
      "alert--error": type === "error",
      "alert--inline": inline,
    },
    className
  );
  return (
    <div role="alert" className={classes} {...props}>
      {children}
    </div>
  );
};

Alert.propTypes = {
  /**
   * Determines colour scheme of component. One of `["info", "success", "warning", "error"]` |
   */
  type: PropTypes.oneOf(["info", "success", "warning", "error"]),
  /**
   * Content to be rendered inside the alert
   */
  children: PropTypes.node.isRequired,
  /**
   * Custom className to add to the component
   */
  className: PropTypes.string,
  /**
   * Applying styling for inlining the component
   */
  inline: PropTypes.bool,
};

Alert.defaultProps = {
  type: "info",
};

export default Alert;
